function ParagraphBlock({ data }) {
  const { text } = JSON.parse(data);
  return <p className="text-base  my-2">{text}</p>;
}

export default ParagraphBlock;
